import { useTheme } from '@mui/material';

import { WithRef } from '../../../types';
import { getThemeColor } from '../../../utils';
import IconBase, { CastProductIconProps } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#e6522c';

export const CastPrometheus = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const theme = useTheme();
  const isPreset = variant === 'preset';
  const fillColor = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : getThemeColor(theme, color);

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16,30c-2.506,0-4.539-1.674-4.539-3.739h9.077C20.539,28.325,18.507,30,16,30Z"
        fill={fillColor}
      />
      <polygon
        points="23.496 25.023 8.503 25.023 8.503 22.304 23.497 22.304 23.497 25.023 23.496 25.023"
        fill={fillColor}
      />
      <path
        d="M23.443,20.9H8.546c-.05-.057-.1-.113-.148-.171A10.867,10.867,0,0,1,6.15,16.905c-.006-.033,1.861.381,3.185.679,0,0,.681.158,1.677.339a6.225,6.225,0,0,1-1.524-4c0-3.2,2.452-5.992,1.568-8.25.861.07,1.782,1.817,1.844,4.549a9.769,9.769,0,0,0,1.3-4.992c0-1.467.966-3.17,1.933-3.229-.862,1.42.223,2.638,1.188,5.658.362,1.134.316,3.044.595,4.254.093-2.515.525-6.184,2.12-7.45-.7,1.6.1,3.591.657,4.551a8.623,8.623,0,0,1,1.432,4.94,6.17,6.17,0,0,1-1.476,3.983c1.053-.2,1.781-.376,1.781-.376l3.421-.667A9.7,9.7,0,0,1,23.443,20.9Z"
        fill={fillColor}
      />
    </IconBase>
  );
};

CastPrometheus.displayName = 'CastPrometheus';
